import { __decorate } from "tslib";
import { Injectable, inject } from '@angular/core';
import { EMPTY, Observable, concat, defer, ignoreElements, map, of } from 'rxjs';
import _ from 'lodash';
import { SailsSocketService } from '../../modules/sails-socket';
let OrganizationService = class OrganizationService {
    sails = inject(SailsSocketService);
    organizations = new Map();
    _model = { array: [], byId: {} };
    get model() {
        return this._model;
    }
    getOrganizations() {
        return this.createObservable('/organization').pipe(map(({ data }) => {
            data.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }));
            this.updateModel(data);
            return this.model;
        }));
    }
    getOrganizationById(id) {
        const org$ = defer(() => of(this.organizations.get(id) || null));
        const retrieveOrgs$ = this.organizations.size ? EMPTY : this.getOrganizations();
        return concat(retrieveOrgs$.pipe(ignoreElements()), org$);
    }
    updateModel(data) {
        this.organizations.clear();
        this._model.array = [];
        this._model.byId = {};
        _.forEach(data, (org) => {
            this.organizations.set(org.id, org);
            this._model.array.push(org);
            this._model.byId[org.id] = org;
        });
    }
    createObservable(url, method = 'get', data) {
        return new Observable((subscriber) => {
            const subscription = this.sails[method](url, data).subscribe({
                next: (response) => {
                    subscriber.next(response);
                    subscriber.complete();
                },
                error: (error) => subscriber.error(error),
            });
            return () => subscription.unsubscribe();
        });
    }
};
OrganizationService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], OrganizationService);
export { OrganizationService };
